import * as Constants from './Constants';

const initialState = {
  title: '',
  resumeCart: false,
  isresumeapisuccess: '',
};

function resumecartTemplate(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_DATA_SUCCESS:
      return {
        ...state, title: action.response && action.response.data, resumeCart: action.resumeCart, isresumeapisuccess: action.isresumeapisuccess,
      };
    default:
      return state;
  }
}


export default resumecartTemplate;
